import Helpers from '../../common/core/helpers';

class EggService {

  constructor() {
    this.ee = window.Daily.ee;
    this.initialize();
  }

  _setListeners() {
    // Когда узнали подписку пользователя, отправляем pageView
    window.Daily.ee.on('primeStatusChecked', () => {
      this.pageView(window.location.href, document.referer);
    });
  }

  initialize() {
    this._setListeners();
  }

  _checkEF() {
    if (!window.EF) {
      throw new Error('cant find ef');
    }
  }

  /**
   * Отправляет событие просмотра страницы
   * @param url {string}
   * @param referer {string}
   */
  pageView(url, referer) {
    const _url = url ? url : '';
    const _referer = referer ? referer : '';
    // Проверяем доступность
    this._checkEF();
    // Отправляем событие
    window.EF.send('pageview', {
      url: Helpers.url.toAbsolute(_url),
      referer: Helpers.url.toAbsolute(_referer),
      extra: {
        user_rsid: window.rsid,
        mobile: window.is_mobile,
      }
    });
  }

}

const service = new EggService();
export default service;



// WEBPACK FOOTER //
// ./daily/assets/id/services/egg.service.js